import styled from "@emotion/styled";
import { FC, useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Bread } from "../../common/component/Bread";
import { ImageFill } from "../../common/component/ImageFill";
import { PaginationComponent } from "../../common/component/PaginationComponent";
import { NewsItem } from "../../module/news/component/NewsItem";
import { NewsTypeEntity } from "../../module/news/entity/news.type.entity";
import newsService from "../../module/news/service/news.service";
import newsTypeService from "../../module/news/service/news.type.service";

export const NewsList: FC = () => {
	const [info, setInfo] = useState<NewsTypeEntity>({});
	const [newsArr, setNewsArr] = useState([]);
	const [total, setTotal] = useState<number>(0);
	const [pageNum, setPageNum] = useState<number>(1);

	const {id} = useParams();

	const init = useCallback(async () => {
		const typeId = Number(id);
		if (typeId) {
			const { data } = await newsTypeService.detail(Number(typeId));
			setInfo(data);

			const newsRes = await newsService.list({newsTypeId: typeId, pageNum});
			setNewsArr(newsRes.data.data);
			setTotal(newsRes.data.total);
		}
	}, [id, pageNum]);

	useEffect(() => {
		window.scrollTo(0, 0);
		init();
	}, [init]);

	const breadArr = [
		{
			title: "新闻中心",
			link: "/newsroom"
		},
		{
			title: info.title
		}
	]

	return (
		<Container>
			<ImageFill src={info.image} width={1600} height={500} areaHeight={296} />
			<div className='content'>
				<div className='page-title'>
					<h1>{info.title}</h1>
				</div>
				<Bread value={breadArr} />
				<div className='list'>
					{newsArr &&
						newsArr.map((item, index) => {
							return (
								<NewsItem key={index} value={item} />
							);
						})}
				</div>
				<PaginationComponent value={total} onChange={(page:number) => setPageNum(page)} />
			</div>
		</Container>
	);
};
const Container = styled.div`
	width: 100%;

	.content {
		background: white;
		padding: 1rem;
		z-index: 10;
		position: relative;

		.list {
			display: flex;

			.item {
				padding: 1rem;
			}
		}
	}
`;
